import { makeStyles, fade } from '@material-ui/core/styles';

export const PaymentDetailsCss = makeStyles((theme) => ({

    transactionDetailsDrawer: {
        width: 475,
        maxWidth: 475,
        [theme.breakpoints.down('sm')]: {
            top: '56px!important',
            height: 'calc(100vh - 0px)'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px!important',
            height: 'calc(100vh - 0px)'
        },
        zIndex: theme.zIndex.drawer + 99
    },
    modal: {
        [theme.breakpoints.down('sm')]: {
            top: '0px'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px'
        },
        zIndex: theme.zIndex.drawer + 99
    },
    backdrop: {
        [theme.breakpoints.down('sm')]: {
            top: '0px'
        },
        [theme.breakpoints.up('sm')]: {
            top: '0px'
        }
    },
    divTitle: {
        fontSize: 18,
        fontWeight: 600,
        color: '#0b1323'
    },
    sideBarDialogContentV1: {
        paddingLeft: 30,
        paddingRight: 30,
        paddingTop: 32,
        paddingBottom: '32px !important',
        backgroundColor: '#f6f6f8'
    },
    cardV1: {
        borderRadius: '8px !important',
        width: '100%',
        boxShadow: 'none !important'
    },
    doneIcon: {
        color: 'white',
        fontSize: '24px'
    },
    pendingIcon: {
        fontSize: '24px'
    },
    divPayment: {
        fontSize: '16px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: '#ffffff'
    },
    cardHeader: {
        paddingLeft: '30px !important',
        paddingRight: '30px !important',
        paddingTop: '12px !important',
        paddingBottom: '12px !important',
        backgroundColor: '#00885a'
    },
    cardHeaderPending: {
        paddingLeft: '30px !important',
        paddingRight: '30px !important',
        paddingTop: '12px !important',
        paddingBottom: '12px !important',
        backgroundColor: '#ffa462'
    },
    cardContent: {
        paddingTop: '16px !important',
        paddingBottom: '16px !important',
        paddingLeft: '16px !important',
        paddingRight: '16px !important'
    },
    titleV1: {
        fontSize: '12px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: '0.01em',
        textAlign: 'left',
        color: 'rgba(11, 19, 35, 0.5)'
    },
    titleV2: {
        fontSize: '12px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: '0.01em',
        textAlign: 'right',
        color: 'rgba(11, 19, 35, 0.5)'
    },
    textV1: {
        fontSize: '16px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterspacing: 'normal',
        textAlign: 'left',
        color: '#0b1323',
        marginTop: 2
    },
    textV2: {
        fontSize: '16px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterspacing: 'normal',
        textAlign: 'right',
        color: '#0b1323',
        marginTop: 2
    },
    textV3: {
        fontSize: '16px',
        fontWeight: 600,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterspacing: 'normal',
        textAlign: 'right',
        color: '#0b1323',
        marginTop: 2
    },
    textV4: {
        fontSize: '16px',
        fontWeight: 600,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterspacing: 'normal',
        textAlign: 'left',
        color: '#0b1323',
        marginTop: 2
    },
    sideBarActions: {
        paddingTop: 24,
        paddingBottom: '24px !important',
        paddingLeft: 30,
        paddingRight: 30,
        display: 'flex',
        justifyContent: 'flex-end'
    },
    divTitleContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        paddingRight: '24px',
        alignItems: 'center'
    },
    divAlign: {
        display: 'flex',
        alignItems: 'center',
    },
    editButton: {
        border: '1px solid #0033cc',
        borderRadius: '4px !important',
        width: '28px',
        height: '28px'
    },
    deleteButton: {
        border: '1px solid #de1c22',
        borderRadius: '4px !important',
        width: '28px',
        height: '28px'
    },
    editIcon: {
        color: '#0033cc',
        fontSize: 16
    },
    deleteIcon: {
        color: '#de1c22',
        fontSize: 16
    },
    mrV1: {
        marginRight: 16
    },
    dialogTitleV1: {
        paddingLeft: '30px !important',
        paddingTop: '8px !important',
        paddingBottom: '8px !important',
        paddingRight: '18px !important',

        '& .MuiTypography-root': {
            width: '100% !important'
        }
    },
    mtV1: {
        marginTop: 16
    },
    divV25: {
        fontWeight: 'bold', fontSize: '16px'
    },
    mtV5: {
        marginTop: '8px'
    },
    cancelV1: {
        color: '#6b778c', fontWeight: 'bold', fontSize: '16px', marginRight: '6px', letterSpacing: '0.05em'
    },
    deleteV1: {
        color: 'red', fontWeight: 'bold', fontSize: '16px', letterSpacing: '0.05em'
    },

}))
